import { createGlobalState, useEventBus } from '@vueuse/core';

const useVideoEvents = createGlobalState(() => useEventBus('videoEvents'));

export default useVideoEvents;
